import './App.css';
import Sec1Home from './Components/sec1-Home/Sec1Home.jsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Sec4Questions from './Components/sec4-Questions/Sec4Questions.jsx';

function App() {
  return (
    <div className="App">
      <Router basename='/global-capability-center-maturity-index'>
        <Routes>
          <Route path='/' exact Component={Sec1Home} />
          <Route path='/survey' exact Component={Sec4Questions} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
